'use client';
import Link from 'next/link';
import { eventTrackingUtils } from '@/utils/eventTrack/eventTrackingUtils';
import { CLParam, spmTrackingUtils } from '@/intl-jdi-common-ssr/utils/spmTrackUtils';

export default function SafeLink(
  props: React.ComponentProps<typeof Link> & {
    trackClickParams?: {
      event_id?: string; // 点击事件id
      json_param?: Record<string, any> | (() => void); // 点击埋点参数
    };
    spmClickParams?: CLParam;
  },
) {
  const safeProps = Object.assign({}, props, { href: props?.href || '#' });
  const { trackClickParams, spmClickParams, ...rest } = safeProps || {};

  const onTrack = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    if (trackClickParams?.event_id) {
      const { event_id, json_param } = trackClickParams;
      const jsonParam = typeof json_param === 'function' ? json_param() : json_param;
      eventTrackingUtils.submitCL({ event_id, json_param: jsonParam });
    }
    if (spmClickParams) {
      spmTrackingUtils.spmClick({ target: e.target as HTMLElement, ...spmClickParams });
    }
  };

  const onClick = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
    onTrack(e);
    safeProps?.onClick?.(e);
  };

  return (
    <Link {...rest} onClick={onClick}>
      {props.children}
    </Link>
  );
}
